export const status = {
  NEU: 'Neu',
  IN_BEARBEITUNG: 'In Bearbeitung',
  FREIGEGEBEN: 'Freigegeben',
  ZURUECKGEWIESEN: 'Zurueckgewiesen',
};
